import { default as _91_46_46_46slug_93u3nAuHUyR8Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/[...slug].vue?macro=true";
import { default as indexmyjUpHTCCzMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/auth/index.vue?macro=true";
import { default as indexcmjw8btoB0Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93Wckzd0Q2u9Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93q2lVgeOkHwMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93OfDiTAiioNMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93oUIA1ukE9CMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/news/[slug].vue?macro=true";
import { default as organisations1UhizCja9nMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventszdnqMPSidVMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsCEvzyEVphDMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexvw5nZKtjHZMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/processes/index.vue?macro=true";
import { default as dungeonxxj51oELYfMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsoPsPtKzeQLMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexWxbiEkZVJbMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/secret/index.vue?macro=true";
import { default as indexU6lOap0JCOMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDatapc00CvvJkAMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassnrociItNDWMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93Ns9aN9fKmyMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexuWZ3RBP6EsMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataqDkEERj6rfMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsuGnFmczmpUMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsTZlld17jUcMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsC02MUX5f0QMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93NEMUk77LCQMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as index7kKCNJOFLzMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesm9U2VO6B2rMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDatanZ8TyNBlavMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93xSjltB7xRmMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexjQGsLyu7t1Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesixQfpnWYAnMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseData226VfPSEXyMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93Ddxr9jIDSHMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexRkpy9phwYHMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataPfRWtL4r1iMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93hjgc39h84SMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexSMiA0Hq0gMMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataWpjWvX30gyMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassJYp42hvI8DMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsgnNwlPQek1Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93MUAebWfaiiMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexD2M4kcrrO0Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitieskdqhy6oR0mMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDatabTg7R06uRBMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsaFMYN9gh15Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as statisticSurveyRightsbW9XhtVEFVMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyRights.vue?macro=true";
import { default as _91id_93MJuhbPqzW7Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexQifGnlEnhuMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesvVZGWVA2XCMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataU4BrrlgKM0Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotifications3xD8Ps75vGMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_932WnGTzBR6rMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexxIXWsVCNKvMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseData9qA1OAlI1gMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDatahSNJDHmo9NMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93gU9C47g9n0Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexF7YfNfee83Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDataDcSumicoDyMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93mLma1NU6QcMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexEzAyzUmvVpMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroups8e5NkxTbvhMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDataWJQh93N5uNMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93ysTQcl2VCtMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexgasUw9V4cXMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesTvmWDVZFbwMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesWZ1vRKOVR4Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsfq2vdOkjN9Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDatac7Hji4WJl5Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiasK9McvoxfJEMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesysGCYbMUZVMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93H2GWrstt4VMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexZUaOFcBtD9Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsSsQ8DuAp3LMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltgiSjhKjZVRMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDatajfNJgQvcCzMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsIcNFLyqYv9Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93FORcyVqC1zMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as index9CP0h6rdcXMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsFck79XTOAfMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/payments.vue?macro=true";
import { default as processActivitiesjTlvFV494JMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataKzv1vYLF2hMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93OOdRMsXmL6Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/processes/[id].vue?macro=true";
import { default as indexodZ1OSdnFgMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovaldhOyd87BCkMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93k6D3e1CkVHMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexc9ldrkyvDZMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProviderswisR2D2VdaMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesEsE7xyQoYlMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingslhRp7fMV2uMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDatayde0wpdMVeMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesDMUl0lssEKMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConcept2yGP3bkpc8Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreement5ahkymKXIUMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUserssvj07kIobMMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93DtcqQU9LSMMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexNdIyKRjopKMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisations0G6kepKdUuMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesvDHWRAK0vLMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataWqG48Y47lFMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFiltershQnZ3Ka4qNMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignatureyVhgKoYtVAMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93RJx5myVbTyMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexg0v7vrfroiMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/index.vue?macro=true";
import { default as userssBDmEsHj8IMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users.vue?macro=true";
import { default as settings0QFuelPi1YMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesiMH0eMPnMbMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDataCC5jwkJzCLMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93M5kpQ9a3bAMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexrwELiV1xtrMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as serviceXa5ztU5XEWMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service.vue?macro=true";
import { default as languageOjoC0LlvcKMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDatarCMMMW25gBMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategories3jeTK8d2dOMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementIpvjWi0xDBMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsers9BZbekC6xdMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93g0kPKHw2HYMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDatayalqJnUj4iMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignature9HQzuORiBzMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93cpqgzGpSXmMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/users/[id].vue?macro=true";
import { default as indexUxrRMRmfwIMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/users/index.vue?macro=true";
import { default as settingscf91CRg02aMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings.vue?macro=true";
import { default as signatureQJFxamXXJmMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/signature.vue?macro=true";
import { default as sportbizzD6r5rbj2WWMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/sportbizz.vue?macro=true";
import { default as _91id_932ugIQ8lNXZMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93dB7ZX6fTO1Meta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexLtRLD6uymOMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93PUWfOtGCXKMeta } from "/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93u3nAuHUyR8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexmyjUpHTCCzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexcmjw8btoB0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93Wckzd0Q2u9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93q2lVgeOkHwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93OfDiTAiioNMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisations1UhizCja9nMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexvw5nZKtjHZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: serviceXa5ztU5XEWMeta?.name,
    path: "/service",
    meta: serviceXa5ztU5XEWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDataDcSumicoDyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexU6lOap0JCOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93Ns9aN9fKmyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexuWZ3RBP6EsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93NEMUk77LCQMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: index7kKCNJOFLzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93xSjltB7xRmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexjQGsLyu7t1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93Ddxr9jIDSHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexRkpy9phwYHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93hjgc39h84SMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexSMiA0Hq0gMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93MUAebWfaiiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexD2M4kcrrO0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93MJuhbPqzW7Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyRights",
    path: "statisticSurveyRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyRights.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexQifGnlEnhuMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_932WnGTzBR6rMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotifications3xD8Ps75vGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexxIXWsVCNKvMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93gU9C47g9n0Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexF7YfNfee83Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93mLma1NU6QcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesTvmWDVZFbwMeta?.name,
    path: "parishes",
    meta: parishesTvmWDVZFbwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93ysTQcl2VCtMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsSsQ8DuAp3LMeta?.name,
    path: "regions",
    meta: regionsSsQ8DuAp3LMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93H2GWrstt4VMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsFck79XTOAfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93FORcyVqC1zMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: index9CP0h6rdcXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93OOdRMsXmL6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexodZ1OSdnFgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovaldhOyd87BCkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settings0QFuelPi1YMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProviderswisR2D2VdaMeta?.name,
    path: "loginProviders",
    meta: loginProviderswisR2D2VdaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93k6D3e1CkVHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexc9ldrkyvDZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisations0G6kepKdUuMeta?.name,
    path: "organisations",
    meta: organisations0G6kepKdUuMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93DtcqQU9LSMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexNdIyKRjopKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: userssBDmEsHj8IMeta?.name,
    path: "users",
    meta: userssBDmEsHj8IMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93RJx5myVbTyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexg0v7vrfroiMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93M5kpQ9a3bAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexrwELiV1xtrMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingscf91CRg02aMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93g0kPKHw2HYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93cpqgzGpSXmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexUxrRMRmfwIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureQJFxamXXJmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzD6r5rbj2WWMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_932ugIQ8lNXZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93dB7ZX6fTO1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexLtRLD6uymOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93PUWfOtGCXKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250704073539/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]